<template>
  <div>
    <section class="hero is-is-bold">
      <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div class="navbar-end">
              <div class="tabs is-right">
                <span v-if="!isAuthenticated" class="navbar-item">
                  <router-link
                    :to="{ name: 'login' }"
                    class="button is-dark is-outlined"
                    data-tooltip="Tooltip Text"
                  >
                    <i class="material-icons">person</i>&nbsp; Mi cuenta
                  </router-link>
                </span>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="hero-body">
        <div class="container has-text-centered">
          <span>
            <img width="50%" src="@/assets/logo2.png" alt="Logo" />
          </span>
        </div>
      </div>
    </section>
    <section class="section has-text-centered">
      <div class="container">
        <h1 class="title">NUESTRO PROPÓSITO.</h1>
        <p>
          El bienestar y el desarrollo de las personas, las organizaciones y la
          sociedad.
        </p>
        <br />
        <h1 class="title is-5">NUESTRA PROPUESTA DE VALOR</h1>
        <p>
          Desde la ciencia, nuestra experiencia y formación, analizamos las
          realidades de personas y organizaciones para crear entornos de trabajo
          saludables.
        </p>
        <br />
        <h1 class="title is-4">EXPERIENCIAS</h1>
        <div class="columns is-multiline">
          <div class="column is-6">
            <div class="box has-background-light">
              <h1 class="title is-5">Diagnóstico</h1>
              <p class="has-text-justified">
                Evaluamos y diseñamos instrumentos válidos y confiables para
                medir realidades psicosociales clave y tomar mejores decisiones
                sobre la calidad de vida de las personas en el trabajo.
              </p>
            </div>
          </div>
          <div class="column is-6">
            <div class="box has-background-light">
              <h1 class="title is-5">Liderazgo</h1>
              <p class="has-text-justified">
                Acompañamos a los líderes en un proceso transformación y
                mejoramiento que les permite inspirar y guiar a otros en su
                desarrollo.
              </p>
            </div>
          </div>
          <div class="column is-6">
            <div class="box has-background-light">
              <h1 class="title is-5">Conferencias</h1>
              <p class="has-text-justified">
                Generamos reflexiones sobre la importancia y efectos del
                bienestar y el desempeño de las personas en el trabajo.
              </p>
            </div>
          </div>
          <div class="column is-6">
            <div class="box has-background-light">
              <h1 class="title is-5">Transformación</h1>
              <p class="has-text-justified">
                Creamos espacios para el aprendizaje y desarrollo de habilidades
                para hacer mejores personas y mejores organizaciones.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <y-Footer></y-Footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import yFooter from "@/components/core/Footer.vue";
export default {
  data() {
    return {
      phoneNumber: "3105349585",
      mensajeBasico: "Quiero saber sobre el plan básico de yungol",
      mensajeRecomendado: "Quiero saber sobre el plan recomendado de yungol",
    };
  },
  computed: {
    ...mapState(["isAuthenticated"]),
  },
  methods: {
    registroGoogle() {
      this.$store.dispatch("notify", {
        message: "Este es un mensaje de prueba",
        type: "is-link",
      });
      this.$ga.event("landing", "prueba"); // con esto se registran eventos en google analytics
    },
  },
  components: {
    yFooter,
  },
};
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/components/core/Landing.vue